import React from "react";
import { Navigate, useParams } from "react-router-dom";

const ChatDetail = () => {
  const { conversationId } = useParams();

  return (
    <Navigate
      to={conversationId ? `/chat?conversationId=${conversationId}` : "/chat"}
      replace
    />
  );
};

export default ChatDetail;
